import { useEffect, useState } from 'react';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { MenuServicio } from '../../service/MenuServicio';
import { useLazyParams } from '../../hooks/useLazyParams';
import { TablaDinamica } from '../../components/TablaDinamica';
import { MenuPermiso as MenuPermisoModel } from '../../models/administracion/MenuPermiso'; 
import { Generico } from '../../components/Generico';

export const MenuPermiso = ({ id, toast, permss }) => {

    const tablaEstado = useLazyParams({ modelo: MenuPermisoModel });
    const [sasignar, setSasignar] = useState([]);
    const menuService = new MenuServicio();
    const { funcSuccess, funcSistemaError } = Generico();

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tablaEstado.lazyParams, id]);

    const loadLazyData = () => {
        const params = { id: id, ...tablaEstado.lazyParams };
        tablaEstado.setLoading(true);
        menuService.getPermisos({ lazyEvent: JSON.stringify(params) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            const asignados = res.data.registros.filter(r => r.fecha).map(r => Number(r.id)); // Sincronizamos el checkbox con la BD
            setSasignar(asignados);
        }).catch(error => {
            funcSistemaError(error, toast);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    };

    const asignar = (e, rowData) => {
        const checked = e.checked;
        const idPermiso = rowData.id;
        setFilaLoading(idPermiso, true); // Modificamos la data visual para mostrar spinner
        tablaEstado.setLoading(true);
        menuService.putPermiso({ id: idPermiso, menu: id, agregar: checked }).then(res => {
            tablaEstado.refreshData();
            funcSuccess(res, toast);
        }).catch(error => {
            setFilaLoading(idPermiso, false);
            tablaEstado.setLoading(false);
            funcSistemaError(error, toast);
        }); // Al refrescar la tabla, se llama a loadLazyData, que cuando finaliza coloca loading en false
    };

    const columnaAsignarTemplate = (rowData) => {
        if (!permss?.actualizar && !permss?.crear) return null;
        const rowId = rowData.id;
        const isProcessing = rowData.loading === true; // Leemos la propiedad directa de la fila
        return (
            <div className="flex justify-content-center align-items-center" style={{ height: '2rem' }}>
                {isProcessing ? (
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5rem', color: 'var(--primary-color)' }}></i>
                ) : (
                    <Checkbox onChange={e => asignar(e, rowData)} checked={sasignar.includes(rowId)} />
                )}
            </div>
        );
    };

    const setFilaLoading = (idPermiso, isLoading) => {
        tablaEstado.setData(prevData => {
            return prevData.map(row => {
                if (row.id === idPermiso) { return { ...row, loading: isLoading }; }
                return row;
            });
        });
    };

    const ColumnaAcciones = (
        <Column header="Asignar" body={columnaAsignarTemplate} style={{ width: '10%', textAlign: 'center' }} />
    );

    return (
        <TablaDinamica modelo={MenuPermisoModel} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
    );
};